<template>
  <VAppBar class="text-caption" height="50">
    <v-row>
      <v-col class="bottom pt-4 px-md-0" cols="12">
        <v-container class="py-lg-0 px-lg-0">
          <v-row justify="space-between" align="center">
            <v-col cols="auto" lg="2" class="px-0">
              <nuxt-link to="/">
                <v-img
                  width="200"
                  src="https://epd.zentek.dev/assets/8932063c-5a11-4ca1-88fe-8de66054f8b8"
                  srcset="https://epd.zentek.dev/assets/8932063c-5a11-4ca1-88fe-8de66054f8b8 1x, https://epd.zentek.dev/assets/8932063c-5a11-4ca1-88fe-8de66054f8b8 2x"
                  alt="Containerdienst.de" />
              </nuxt-link>
            </v-col>

            <v-col cols="6" class="d-none d-lg-block">
              <v-stepper v-model="activeStep" alt-labels flat>
                <v-stepper-header>
                  <div class="cursor-pointer mr-6" @click="navigateTo('/warenkorb')">
                    <v-stepper-item ref="cartstep" :title="t('cart')" value="cart" />
                  </div>
                  <v-divider />

                  <v-stepper-item
                    :title="t('checkout')"
                    value="checkout"
                    :class="{ 'v-stepper-item--selected': currentPath.includes('kasse') }" />

                  <v-divider />

                  <v-stepper-item
                    :title="t('confirmation')"
                    value="confirmation"
                    :class="{
                      'v-stepper-item--selected': currentPath.includes('bestellbestaetigung'),
                    }" />
                </v-stepper-header>
              </v-stepper>
            </v-col>

            <v-col cols="auto" class="d-none d-md-block px-0">
              <v-row align="center" justify="start">
                <v-col cols="auto">
                  <div id="trustbadgeCustomContainer" />
                </v-col>
                <v-col v-if="mdAndUp" cols="auto" class="pl-0 pr-3">
                  <v-img
                    width="75"
                    :src="`https://epd.zentek.dev/assets/c3479603-3cde-4536-b30b-b229d4a3f30f?format=webp`"
                    :srcset="`https://epd.zentek.dev/assets/c3479603-3cde-4536-b30b-b229d4a3f30f?format=webp 1x, https://epd.zentek.dev/assets/c3479603-3cde-4536-b30b-b229d4a3f30f?format=webp 2x`"
                    alt="QMS Managementsystem" />
                </v-col>
                <v-col v-if="mdAndUp" cols="auto" class="px-0">
                  <v-img
                    width="75"
                    :src="`https://epd.zentek.dev/assets/ac924a20-0d75-4842-8aa2-1b83304d0033?format=webp`"
                    :srcset="`https://epd.zentek.dev/assets/ac924a20-0d75-4842-8aa2-1b83304d0033?format=webp 1x, https://epd.zentek.dev/assets/ac924a20-0d75-4842-8aa2-1b83304d0033?format=webp 2x`"
                    alt="QMS Entsorguungsfachbetrieb" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </VAppBar>
</template>
<script setup lang="ts">
import { useDisplay } from 'vuetify'

const { t } = useI18n()
const route = useRoute()
const { mdAndUp } = useDisplay()
const cartstep = ref()
const currentPath = computed(() => route.path)

const activeStep = computed(() =>
  currentPath.value.includes('warenkorb')
    ? 'cart'
    : currentPath.value.includes('kasse')
      ? 'checkout'
      : 'confirmation',
)

onMounted(() => {
  const { $loadTrustedShopsScript } = useNuxtApp()
  $loadTrustedShopsScript()
  if (currentPath.value.includes('kasse')) {
    const element = cartstep.value.$el as HTMLElement
    element?.removeAttribute('disabled')
  }
})
</script>

<style lang="scss" scoped>
.v-stepper-header {
  :deep(.v-avatar) {
    width: 11px !important;
    height: 11px !important;
    font-size: 0 !important;
    margin-top: 5px;
  }
  :deep(.v-stepper-item__title) {
    text-transform: uppercase;
  }
}
:deep(#trustbadgeCustomContainer > div > div > div) {
  position: relative !important;
  margin: inherit !important;
  font-size: inherit !important;
  font-family: inherit !important;
  font-weight: inherit !important;
  color: inherit !important;
  line-height: inherit !important;
  text-align: inherit !important;
  box-shadow: none !important;
  float: none !important;
  display: block !important;
  left: unset !important;
  right: unset !important;
  bottom: unset !important;
  opacity: inherit !important;
  visibility: inherit !important;
  p {
    font-size: 10px !important;
  }
}
:deep(#trustbadgeCustomContainer > div > div > div > div > div > div) {
  transform: scale(0.8) !important;
}
:deep(#trustbadgeCustomContainer) {
  ._vbx68m {
    width: 140px !important;
    display: flex !important;
  }
  ._1bcyd8a {
    margin-bottom: 4px !important;
  }
  ._1ehsxge {
    width: 58px !important;
    height: auto !important;
  }
}
</style>
